$.fn.dropDown = function() {
    $(this).each(function() {
        if ($(this).hasClass('dropdown-is-active')) {
            return true;
        }

        const $this = $(this),
            $btn = $this.find('.c-dropdown__btn'),
            $list = $this.find('.c-dropdown__list'),
            $link = $this.find('.c-dropdown__link');

        $btn.on('click', function(event) {
            event.preventDefault();

            $this.toggleClass('is-active');
            toggleOverlay();
        });

        $list.on('click', '.js-print', function() {
            $btn.trigger('click');
        });

        $link.on('click', function(event) {
            if ($(this).hasAttr('data-trigger')) {
                event.preventDefault();

                $('.' + $(this).attr('data-trigger')).trigger('click');
            }

            if ($(this).hasAttr('data-submit')) {
                event.preventDefault();

                $('.' + $(this).attr('data-submit')).trigger('submit');
                $btn.trigger('click');
            }
        });

        $this.addClass('dropdown-is-active');
    });
};

Event.on('Listing.fetchedData', function() {
    $('.js-dropdown').dropDown();
});

$(function () {
    $('.js-dropdown').dropDown();

    $('.c-overlay').on('click', function () {
        $('.js-dropdown').removeClass('is-active');
    });
});
